import Vue from 'vue';
import Router from 'vue-router';
import layout from '@/components/layout/index.vue';

Vue.use(Router);

export default new Router({
  // history模式，路由上无#号，但是打包后刷新路由会加载不到内容，具体要nginx配置，所以要改成hash模式打包
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/404',
      component: resolve => require(['@/components/404/index.vue'], resolve)
    },
    { // login
      path: '/login',
      name: 'login',
      component: resolve => require(['@/components/login/index.vue'], resolve)
    },
    { // forgetPassword
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: resolve => require(['@/components/forgetPassword/index.vue'], resolve)
    },
    {
      path: '/layout',
      component: layout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: resolve => require(['@/views/home/index.vue'], resolve),
          meta: { keepAlive: true }
        },
        {
          path: '/activity',
          component: resolve => require(['@/views/activity/index.vue'], resolve)
        },
        {
          path: '/user',
          component: resolve => require(['@/views/user/index.vue'], resolve)
        },
        {
          path: '/user-settings',
          component: resolve => require(['@/views/user-settings/index.vue'], resolve)
        },
        {
          path: '/blog-detail',
          component: resolve => require(['@/views/blog-detail/index.vue'], resolve)
        },
        {
          path: '/blog-editor',
          component: resolve => require(['@/views/blog-editor/index.vue'], resolve)
        },
        {
          path: '/authors',
          component: resolve => require(['@/views/authors/index.vue'], resolve)
        },
        {
          path: '/password-settings',
          component: resolve => require(['@/views/password-settings/index.vue'], resolve)
        }
      ]
    },

    {
      path: '/xiaoliu',
      component: resolve => require(['@/views/xiaoliu/index.vue'], resolve)
    }
  ]
  // scrollBehavior (to, from) {
  //   console.log(to, 'to');
  //   if (to.path === '/home') {
  //     console.log(to.path, 'to2222');
  //     let scrollY = +localStorage.getItem('homeScrollY') || 0;
  //     return { x: 0, y: scrollY };
  //   }
  // }
});



// WEBPACK FOOTER //
// ./src/router/index.js